<template>
	<div class="margin-left">
		<div class="flex align-center topall bg-white margin-bottom-sm">
			<p @click="chose(item)" class="flex-sub text-center pointer" :class="topindex == item.id?'active text-theme':''" v-for="(item,index) in top" :key="index">{{item.name}}</p>
			
		</div>
		<div class="flex align-center justify-between padding-lr release margin-bottom-sm">
			<p class="text-theme text-sm">免费发布招工信息，让工人主动联系您</p>
			<p class="release-btn text-white text-sm pointer" @click="godetail('release')">免费发布</p>
		</div>
		<!-- TODO  对接数据 -->
		<div v-if="total != 0">
			<div v-for="(item,indx) in list" :key="indx">
				<RecruitList :data="item" @godetail="todetail"></RecruitList>
			</div>
			<div class="pagination">
				<el-pagination
				  background
				  @current-change="handleCurrentChange"
				  layout="prev, pager, next"
				  prev-text="上一页"
				  next-text="下一页"
				  :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="text-center" v-else>
			<el-empty description="暂无数据"></el-empty>
		</div>
		<!-- <div class="flex flex-direction align-center justify-center" @click="godetail('release')">
			<img class="nobill" src="../../../assets/img/nobill.png" >
			<div class="invoice text-white">免费发布</div>
		</div> -->
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import RecruitList from '../../list/recruit-list.vue';
	export default {
		components: {
			RecruitList,
		},
		data() {
			return {
				top:[
					{
						name:'全部',
						id:4
					},{
						name:'审核中',
						id:0
					},{
						name:'正在招',
						id:1
					},{
						name:'未通过',
						id:2
					},{
						name:'已招满',
						id:3
					}
				],//状态
				topindex:4,//选中的状态下表
				page:1,
				list:[],
				total:0,//
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			//选中状态
			chose(item){
				this.topindex = item.id
				this.page = 1
				this.getlist()
			},
			//通知center 跳转对应页面
			godetail(index,typeone){
				let one = typeone?typeone:''
				let type = {
					type:index,
					typeone:one
				}
				this.$emit('gettype',type)
			},
			todetail(e){
				console.log(e);
				this.godetail('recruitetail','recruit')
				// this.$emit('',e.)
				setTimeout(() => {
				     Bus.$emit('detailid',e.id)
				   }, 20);
				
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			getlist(){
				this.ajax('get', '/api/pc/work/getMyWorkList', {
					status:this.topindex,
					page:this.page,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.list = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.topall{
		width: 921px;
		height: 69px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
		p{
			height: 69px;
			line-height: 69px;
		}
	}
	.release{
		width: 921px;
		height: 55px;
		line-height: 55px;
		background: rgba(11,131,124,0.1);
		box-shadow: 0px 4px 19px 0px rgba(208,208,208,0.05);
		border-radius: 8px;
		.release-btn{
			width: 100px;
			height: 35px;
			line-height: 35px;
			background: #0B837C;
			box-shadow: 0px 4px 19px 0px rgba(208,208,208,0.05);
			border-radius: 18px;
		}
	}
	.nobill{
		width: 180px;
		height: 139px;
		margin-top: 100px;
		margin-bottom: 32px;
		font-size: 22px;
	}
	.invoice{
		width: 165px;
		height: 50px;
		line-height: 50px;
		background: #09827B;
		box-shadow: 3px 4px 19px 1px rgba(10,114,108,0.2000);
		border-radius: 25px;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
	.active{
		
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
			content: '';
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/recruit/list.vue